import { h } from 'preact'

export default function studyRewardNotificationInboxZeroView ({ hitInboxZero }) {
  return hitInboxZero && h('div', {
    class: 'reward-notification good'
  }, 'You just hit inbox zero! 📥')
}
